'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import AppLayout from '@/components/AppLayout';

const DashboardHeader = dynamic(() => import('./components/DashboardHeader'), { ssr: false });
const DashboardKPIs = dynamic(() => import('./components/DashboardKPIs'), { ssr: false });
const HostStatusGrid = dynamic(() => import('./components/HostStatusGrid'), { ssr: false });
const DashboardResponseChart = dynamic(() => import('./components/DashboardResponseChart'), { ssr: false });
const RecentAlertFeed = dynamic(() => import('./components/RecentAlertFeed'), { ssr: false });

export default function NetworkMonitoringDashboardPage() {
  return (
    <AppLayout>
      <div className="px-6 py-6 max-w-screen-2xl mx-auto">
        <DashboardHeader />
        <DashboardKPIs />
        <HostStatusGrid />
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 mt-5">
          <div className="xl:col-span-2">
            <DashboardResponseChart />
          </div>
          <div>
            <RecentAlertFeed />
          </div>
        </div>
      </div>
    </AppLayout>
  );
}